import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { getToken } from '../../utils/auth';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const formatearFecha = (fechaISO) => {
  const [año, mes, dia] = fechaISO.split('-');
  return `${dia}/${mes}/${año}`;
};

const formatearHora = (hora) => {
  const [h, m] = hora.split(':');
  return `${h.padStart(2, '0')}:${m.padStart(2, '0')}`;
};

const claseFila = (asistencia) => {
  if (!asistencia || asistencia === 'pendiente') return 'pendiente';
  if (asistencia.toLowerCase() === 'pendiente_pagar') return 'pendiente-pago';
  if (asistencia.toLowerCase() === 'necesita_confirmacion') return 'necesita-confirmacion';
  if (asistencia.toLowerCase() === 'no_asistio') return 'no-asistio-asistencia';
  if (asistencia.toLowerCase() === 'asistio') return 'asistio';
  return '';
};


const textoAsistencia = (asistencia) => {
  if (!asistencia || asistencia === 'pendiente') return 'Pendiente';
  if (asistencia.toLowerCase() === 'pendiente_pagar') return 'Pendiente (debe abonar anterior cita)';
  if (asistencia.toLowerCase() === 'necesita_confirmacion') return 'Necesita confirmación';
  if (asistencia.toLowerCase() === 'no_asistio') return 'No';
  if (asistencia.toLowerCase() === 'asistio') return 'Sí';
  return asistencia;
};


const TELEFONO_ESPECIAL = '34636545966';

const AsistenciasAdmin = () => {
  const [citas, setCitas] = useState([]);
  const [confirmaciones, setConfirmaciones] = useState([]);
  const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
  const telefonoLogueado = localStorage.getItem('telefono');

  const cargarCitas = async (fechaBuscar = fecha) => {
    const token = getToken();
    try {
      const res = await api.get(`/admin/citas-asistencia?fecha=${fechaBuscar}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCitas(res.data.citas || []);
    } catch (err) {
      console.error('❌ Error al cargar citas:', err);
      toast.error('Error al cargar las citas');
    }
  };

  const cargarConfirmaciones = async () => {
    const token = getToken();
    try {
      const res = await api.get(`/admin/citas-necesitan-confirmacion`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setConfirmaciones(res.data.citas || []);
    } catch (err) {
      console.error('❌ Error al cargar confirmaciones:', err);
      toast.error('Error al cargar las citas que necesitan confirmación');
    }
  };

  const actualizarAsistencia = async (id, estado) => {
    const token = getToken();
    try {
      await api.put(
        `/admin/cita/${id}/asistencia`,
        { asistio: estado },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Asistencia actualizada correctamente');
      cargarCitas(fecha);
      cargarConfirmaciones();
    } catch (err) {
      console.error('❌ Error al actualizar asistencia:', err);
      toast.error('Error al actualizar asistencia');
    }
  };

  const eliminarCita = async (id) => {
    const token = getToken();
    if (!window.confirm('¿Estás seguro de que deseas eliminar esta cita? Esta acción no se puede deshacer.')) {
      return;
    }

    try {
      await api.delete(`/admin/cita/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Cita eliminada correctamente');
      cargarCitas(fecha);
      cargarConfirmaciones();
    } catch (err) {
      console.error('❌ Error al eliminar cita:', err);
      toast.error('No se pudo eliminar la cita');
    }
  };

  const handleBuscarFecha = (e) => {
    const nuevaFecha = e.target.value;
    setFecha(nuevaFecha);
    cargarCitas(nuevaFecha);
  };

  useEffect(() => {
    cargarCitas();
    cargarConfirmaciones();
  }, []);

  return (
    <main className="citas-asistencias site-width">
      <div className="texto-dashboard">
        <h1>Gestión de Asistencias</h1>
        <p>Marca si los clientes asistieron a sus citas.</p>
      </div>

      {/* Sección adicional: citas que necesitan confirmación */}
      <div className="texto-intro-confirmacion">
        <h2>Citas pendientes de confirmación</h2>
        <p>Estas son las citas que requieren tu confirmación para que puedan asistir. (Usuarios que han intentado reservar más de una cita en la misma semana)</p>
      </div>
      {confirmaciones.length === 0 ? (
        <p className="warning-msg">No hay citas que necesiten confirmación.</p>
      ) : (
        <>
          <div className="overflow-tabla">

            <div className="tabla-citas-confirmacion">

              <div className="tabla-header">
                <div>Nombre</div>
                <div>Apellidos</div>
                <div>Teléfono</div>
                <div>Fecha</div>
                <div>Hora</div>
                <div>Servicio</div>
                <div>Acciones</div>
              </div>
              {confirmaciones.map(cita => (
                <div key={`confirm-${cita.id}`} className="tabla-row necesita-confirmacion">
                  <div>{cita.Usuario ? cita.Usuario.nombre : '(Usuario eliminado)'}</div>
                  <div>{cita.Usuario ? cita.Usuario.apellidos : '-'}</div>
                  <div>{cita.Usuario ? `+${cita.Usuario.telefono}` : '-'}</div>
                  <div>{formatearFecha(cita.fecha)}</div>
                  <div>{formatearHora(cita.hora_inicio)}</div>
                  <div>{cita.Servicio?.nombre || '-'}</div>
                  <div className="acciones-citas">
                    <button
                      className="boton-guardar"
                      onClick={() => actualizarAsistencia(cita.id, 'pendiente')}
                    >
                      Confirmar
                    </button>
                    <button
                      className="boton-eliminar"
                      onClick={() => eliminarCita(cita.id)}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}



      {/* Buscador por fecha */}
      <div className="buscador-fecha">
        <h3>Buscador de citas por fecha</h3>
        <p>Es importante que selecciones la fecha correcta para gestionar las asistencias de ese día.</p>
        <input
          type="date"
          value={fecha}
          onChange={handleBuscarFecha}
        />
      </div>

      {/* Tabla de citas filtradas por fecha */}
      <div className="overflow-tabla">
        <div className="tabla-citas-asistencias">
          <div className="tabla-header">
            <div>Nombre</div>
            <div>Apellidos</div>
            <div>Teléfono</div>
            <div>Fecha</div>
            <div>Hora Inicio</div>
            <div>Hora Fin</div>
            <div>Asistencia</div>
            <div>Acciones</div>
          </div>

          {citas.map(cita => (
            <div key={cita.id} className={`tabla-row ${claseFila(cita.asistencia)}`}>
              <div>{cita.Usuario ? cita.Usuario.nombre : '(Usuario eliminado)'}</div>
              <div>{cita.Usuario ? cita.Usuario.apellidos : '-'}</div>
              <div>{cita.Usuario ? `+${cita.Usuario.telefono}` : '-'}</div>
              <div>{formatearFecha(cita.fecha)}</div>
              <div>{formatearHora(cita.hora_inicio)}</div>
              <div>{formatearHora(cita.hora_fin)}</div>
              <div>{textoAsistencia(cita.asistencia)}</div>
              <div className="acciones-citas">
                {cita.asistencia === 'necesita_confirmacion' ? (
                  <>
                    <button
                      className="boton-guardar"
                      onClick={() => actualizarAsistencia(cita.id, 'pendiente')}
                    >
                      Confirmar
                    </button>
                    <button
                      className="boton-eliminar"
                      onClick={() => eliminarCita(cita.id)}
                    >
                      Eliminar
                    </button>
                  </>
                ) : (
                  cita.asistencia === 'asistio' || cita.asistencia === 'no_asistio' ? (
                    telefonoLogueado === TELEFONO_ESPECIAL ? (
                      <>
                        <button
                          className="boton-guardar"
                          onClick={() => actualizarAsistencia(cita.id, 'asistio')}
                        >
                          Asistió
                        </button>
                        <button
                          className="boton-eliminar"
                          onClick={() => actualizarAsistencia(cita.id, 'no_asistio')}
                        >
                          No asistió
                        </button>
                      </>
                    ) : (
                      <p className="texto-accion-realizada">✅ Acción realizada</p>
                    )
                  ) : (
                    <>
                      <button
                        className="boton-guardar"
                        onClick={() => actualizarAsistencia(cita.id, 'asistio')}
                      >
                        Asistió
                      </button>
                      <button
                        className="boton-eliminar"
                        onClick={() => actualizarAsistencia(cita.id, 'no_asistio')}
                      >
                        No asistió
                      </button>
                    </>
                  )
                )}

              </div>
            </div>
          ))}
        </div>
      </div>

      <ToastContainer position="bottom-right" autoClose={3000} />
    </main>
  );
};

export default AsistenciasAdmin;
